import { render, staticRenderFns } from "./person_change_detail_pc.vue?vue&type=template&id=2d03e38c&scoped=true&"
import script from "./person_change_detail_pc.vue?vue&type=script&lang=js&"
export * from "./person_change_detail_pc.vue?vue&type=script&lang=js&"
import style0 from "./person_change_detail_pc.vue?vue&type=style&index=0&id=2d03e38c&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d03e38c",
  null
  
)

export default component.exports